import * as React from "react";
import { makeStyles, useTheme, Theme } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';
import { useTranslation } from 'react-i18next';

// All the incoming values
interface IProps {
    disabled?: boolean;
}

// Outgoing functions
interface IDispatch {
    onClick: () => void
}

// Actual Component
export type AllProps = IProps & IDispatch;
export const EnableButton = (props: AllProps) => {
    const classes = useStyles(useTheme());
    const { t } = useTranslation('common');

    return (
        <Button 
            startIcon={<PlayCircleOutlineIcon />} 
            disabled={props.disabled} 
            onClick={props.onClick} 
            variant="contained" 
            color="primary"
        >
            {t('enable')}
        </Button>
    )
}

// CSS
const useStyles = makeStyles((theme: Theme) => ({ }));
